import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    unitsOfMeasurement:null,
    isFetched: null
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async get({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isFetched", value: false });
      return axios
        .get(this._vm.$apiURL + "/goods_nomenclature_unit_of_measurement")
        .then((response) => {
          updateField(state, {
            path: 'unitsOfMeasurement',
            value: response.data,
          });
          return response.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "isFetched", value: true });
        });
    },
  },
};
